import { useState, useEffect } from "react";
import React from "react";
import { machineProfile, vendor, vendorType } from "../../api";
import { toast } from "react-toastify";
import { dateFormat, getEmptyField, printLocation, renderImage } from "../../utils/helper";
import { QRCode } from "react-qrcode-logo";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { useDashboardContext } from "../../contexts/NewDashboardContext";
import LoadingIndicator from "../../components/LoadingIndicator";
import NormalInput from "../../components/form/HorizontalNormalInput";
import NormalSelect from "../../components/form/HorizontalNormalSelect";
import NormalTextArea from "../../components/form/HorizontalNormalTextarea";
import { DatepickerOpt } from "../../components/form/DatepickerOpt";
import DateTime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { Card, CardBody, CardHeader } from "../../components/card/card";
import { PermissionChecker } from "../../components/PermissionChecker/index.jsx";
function setupLocationValues(locationSeq, location) {
  locationSeq.push(location.id);
  if (location.parent_location) {
    setupLocationValues(locationSeq, location.parent_location);
  }
}
function AddVendor({afterSubmitCallback}) {
  const { id } = useParams();
  const editMode = !!id;
  const { locations } = useDashboardContext();
  const [sublocations, setSublocations] = useState([]);

  const [selectedFile, setSelectedFile] = useState("");
  const [machineClasses, setVendorClasses] = useState([]);
  const [filesToUpload, setFilesToUpload] = useState([]);
  const [preview, setPreview] = useState();

  const [locationValue, setLocationValue] = useState([]);
  const { getLocationName } = useAuth();
  const [isLoading, setIsLoading] = useState(true);

  const [dataToSend, setDataToSend] = useState({
    vendor_name: "",
    type_id: "",
    contact_name: "",
    contact_email: "",
    contact_phone: "",
    address: "",
    website: "",
    description: "",
    price:0
  });

  const navigate = useNavigate();
  function backToList() {
    navigate(-1);
  }
  

  const [types, setTypes] = useState([])
  const [newType, setNewType] = useState("")
  const [emptyField,setEmptyField] = useState([])

  const handleAddNewType = async() => {
    
    if (!newType) return;
    const result = await  vendorType.create({
      name:newType
    });

    if (result.ok) {
      const body = await result.json()
      const data = body.data
      setTypes((prev)=>[{...data},...prev])
      setNewType("")
    }


  }

  async function getMasterData() {
    try {
      setIsLoading(true);
      setSublocations([locations]);

      const resType = await vendorType.list({})
      if (resType.ok) {
        const body = await resType.json();
        let data = body.data;
        if (data) {
          setTypes(data);
        }
      }


      if (editMode) {
        await getRecord();
      } else {
        setIsLoading(false);
      }
    } catch (err) {}
  }

  useEffect(() => {
    if (locations.length) getMasterData();
  }, [locations]);

  async function getRecord() {
    const machine = await vendor.getOne({ id });
    let activeVendor;
    if (machine.ok) {
      const body = await machine.json();
      let data = body.data;
      activeVendor = data;
    }

    if (activeVendor) {
      const defaultValue = {
        vendor_name: activeVendor.vendor_name,
        type_id: activeVendor.type_id,
        contact_name: activeVendor.contact_name,
        contact_email: activeVendor.contact_email,
        contact_phone: activeVendor.contact_phone,
        address: activeVendor.address,
        website: activeVendor.website,
        description: activeVendor.description,
        price:activeVendor.price
      };
      setDataToSend((prevData) => ({
        ...prevData,
        ...defaultValue,
      }));
      setIsLoading(false);
    }
  }

  const handleOnchange = (e) => {
    let key = e.target.name;

    setDataToSend((prevData) => ({
      ...prevData,
      [key]: e.target.value,
    }));
  };

  useEffect(() => {
    let sublocations = locations;
    const copy = [sublocations];

    const findSublocation = (lv, index) => {
      const location = sublocations.find((l) => l.id == lv);

      if (
        location &&
        location.sublocations &&
        location.sublocations.length > 0
      ) {
        copy.splice(index + 1);
        copy.push(location.sublocations);
        sublocations = location.sublocations;
      } else {
        copy.splice(index + 1);
      }
    };

    if (locationValue.length > 0) {
      locationValue.forEach((lv, index) => {
        findSublocation(lv, index);
      });
      setSublocations(copy);
    }
  }, [locationValue]);

  const handleSubmit = async () => {
    try {
      let hasil = { ...dataToSend };

      const mandatory = ['vendor_name', 'type_id']
      const ef = getEmptyField(hasil, mandatory)
      setEmptyField(ef)
      if (ef.length > 0) {
        toast.error("Mandatory field must be filled");
        return;
      }



      //console.log({ hasil });
      setIsLoading(true);
      const res = await vendor.create2(hasil, selectedFile);
      setIsLoading(false);
      if (res.ok) {
        toast.success("Successfully Saved");
        if (afterSubmitCallback) {
          afterSubmitCallback()
        } else {
          backToList();
        }
      } else {
        toast.error("Something went wrong, please try again");
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  };

  const handleEdit = async () => {
    try {
      let hasil = { ...dataToSend };
      const mandatory = ['vendor_name', 'type_id']
      const ef = getEmptyField(hasil, mandatory)
      setEmptyField(ef)
      if (ef.length > 0) {
        toast.error("Mandatory field must be filled");
        return;
      }

      setIsLoading(true);
      const res = await vendor.update(id, hasil);
      setIsLoading(false);
      if (res.ok) {
        toast.success("Data Updated");
      } else {
        toast.error("Something went wrong, please try again");
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  };

  useEffect(() => {
    if (!selectedFile) {
      setPreview(undefined);
      return;
    }
    //console.log({ selectedFile });
    const objectUrl = URL.createObjectURL(selectedFile);
    setPreview(objectUrl);
    //console.log({ objectUrl });
    // free memory when ever this component is unmounted
    return () => URL.revokeObjectURL(objectUrl);
  }, [selectedFile]);
  return (
    <Card>
      <LoadingIndicator open={isLoading} />
      <CardHeader>{editMode && "Edit "}Vendor Information</CardHeader>

      <CardBody>
        <div className="row">
          <div className="col-9">
            <div>
              <NormalInput
                required={true}
                value={dataToSend["vendor_name"]}
                label="Vendor Name"
                onchange={handleOnchange}
                name="vendor_name"
                emptyField={emptyField}
              />

<NormalSelect
                required={true}
                value={dataToSend["type_id"]}
                label="Vendor Type"
                onchange={handleOnchange}
                list={types}
                name="type_id"
                emptyField={emptyField}
              valueKey={"id"}
              onSubmit={handleAddNewType}
              addMoreComponent={
                <NormalInput
                required={true}
                value={newType}
                label="Vendor Type"
                onchange={(e)=>{setNewType(e.target.value)}}
              />
              }
              />
              
              <NormalInput
                value={dataToSend["price"]}
                label="Price"
                onchange={handleOnchange}
                name="price"
                type="number"
              />


              <NormalInput
                value={dataToSend["address"]}
                label="Address"
                onchange={handleOnchange}
                name="address"
              />
              <NormalInput
                value={dataToSend["website"]}
                label="Website"
                onchange={handleOnchange}
                name="website"
              />
              <NormalInput
                value={dataToSend["contact_name"]}
                label="Contact Name"
                onchange={handleOnchange}
                name="contact_name"
              />
              <NormalInput
                value={dataToSend["contact_phone"]}
                label="Contact Phone"
                onchange={handleOnchange}
                name="contact_phone"
              />
              <NormalInput
                value={dataToSend["contact_email"]}
                label="Contact Email"
                onchange={handleOnchange}
                name="contact_email"
              />
              <NormalTextArea
                value={dataToSend["description"]}
                label="Description"
                onchange={handleOnchange}
                name="description"
              />
            </div>
          </div>
        </div>

        <div className="mt-4 flex ">
          <PermissionChecker permissions={["create vendor", "edit vendor"]} hideIfNotAllowed>
          <button
            className="btn btn-outline-theme btn-lg me-2"
            onClick={editMode ? handleEdit : handleSubmit}
          >
            {editMode ? "SAVE" : "ADD"}
          </button>
          <button
            className="btn btn-outline-danger btn-lg"
            onClick={afterSubmitCallback?afterSubmitCallback:backToList}
          >
            CANCEL
            </button>
            </PermissionChecker>
        </div>
      </CardBody>
    </Card>
  );
}

export default AddVendor;
